// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2MGHK","inner":"Footer_inner__1Iprz"};